export const QUERY_KEYS = {
  CALL_TRANSCRIPTS: "callTranscripts",
  FAVORITES: "favorites",
  ADDRESS_DATA_BY_ID: "addressDataById",
  ADDRESS_LIST: "addressList",
  ADDRESS_NOTES: "addressNotes",
  ADDRESS_CHANGE_LOG: "addressChangeLog",
  ASSOCIATED_ACCOUNTS: "associatedAccounts",
  NEARBY_DETAILS: "nearbyDetails",
  VERIFIED_DETAILS: "verifiedDetails",
  ADDRESS_COUNTS: "addressCounts",
  UPCOMING_DETAILS: "upcomingDetails",
  TERMINAL_NAME: "terminalName",
  TERMINAL_DELETION_REQUEST: "terminalDeletionRequest",
  NOTIFICATIONS: "notifications",
  EMPLOYEE_NOTIFICATION_PREFERENCES: "employeeNotificationPreferences",
  DRIVER_LIST: "driverList",
  DRIVER_DETAILS: "driverDetails",
  EDIT_DRIVER: "editDriver",
  ZIPCODE_LOCATIONS: "zipcodeLocations",
  TIMEZONE: "timezone",
  LOAD_BOARD_DOORS: "loadBoardDoors",
  EQUIPMENT_LIST: "equipmentList",
  LOADBOARD_LIST: "loadboardList",
  PICKUP_SUMMARY: "pickupSummary",
  INBOUND_FREIGHT_SUMMARY: "inboundFreightSummary",
  INHOUSE_SUMMARY: "inhouseSummary",
  INBOUND_FREIGHT_BY_TERMINAL: "inboundFreightByTerminal",
  INBOUND_FREIGHT_COUNTS: "inboundFreightCounts",
  MANIFEST_DETAILS: "manifestDetails",
  AVAILABLE_DOORS: "availableDoors",
  INHOUSE_FREIGHT_BY_ETA: "inhouseFreightByETA",
  OUTBOUND_PLANNING:"outboundPlanning",
  OUTBOUND_PLANNING_FREIGHT_LIST: "outboundPlanningFreightList",
  OUTBOUND_PLANNING_PICKUP_LIST: "outboundPlanningPickupList",
  GET_MAKES: "GET_MAKES",
  GET_LEASE_TYPES: "GET_LEASE_TYPES",
  GET_ASSET_DESCRIPTOR: "GET_ASSET_DESCRIPTOR",
  GET_EQUIPMENT_TYPES: "GET_EQUIPMENT_TYPES",
  GET_EQUIPMENT_LIST: "GET_EQUIPMENT_LIST",
  GET_TERMINALS_LIST: "GET_TERMINALS_LIST",
  GET_PRODUCT_LINES: "GET_PRODUCT_LINES",
  GET_EQUIPMENT_DETAIL: "GET_EQUIPMENT_DETAIL",
  GET_EQUIPMENT_ACTIVITY_LOG: "GET_EQUIPMENT_ACTIVITY_LOG",
  GET_EQUIPMENT_CHANGE_LOG: "GET_EQUIPMENT_CHANGE_LOG",
  GET_WEEKS: "GET_WEEKS",
  GET_LANE_BY_PLAN_ID: "GET_LANE_BY_PLAN_ID",
  GET_TERMINAL_DETAILS_BY_NUMBER: "GET_TERMINAL_DETAILS_BY_NUMBER",
  GET_LANES_BY_DAY: "GET_LANES_BY_DAY",
  GET_TERMINAL_DETAILS_BY_AIRPORT_CODE: "GET_TERMINAL_DETAILS_BY_AIRPORT_CODE",
  CLONE_WEEK: "CLONE_WEEK",
  GET_CARRIER: "GET_CARRIER",
  CARRIER_ASSIGNMENT_CHANGE_LOG: "carrierAssignmentChangeLog",
  GET_ACTIVITY_LOG: "GET_ACTIVITY_LOG",
  GET_REVIEW_DISPATCH: "GET_REVIEW_DISPATCH",
  GET_SUMMARY_TILES: "GET_SUMMARY_TILES",
  POST_DISPATCH: "POST_DISPATCH",
  GET_DISPATCH_BOARD_QUEUE: "GET_DISPATCH_BOARD_QUEUE",
  GET_DISPATCH_BOARD_QUEUE_LOAD: "GET_DISPATCH_BOARD_QUEUE_LOAD",
  GET_DISPATCH_BOARD_QUEUE_LOAD_DETAILS: "GET_DISPATCH_BOARD_QUEUE_LOAD_DETAILS",
  GET_DISPATCH_BOARD_DOORS: "GET_DISPATCH_BOARD_DOORS",
  GET_STATIC_ROUTES: "GET_STATIC_ROUTES",
  GET_DRIVERS_BY_ZIP: "GET_DRIVERS_BY_ZIP",
  PICKUP_ASSIGNMENT_DRIVERS_COLUMN: "PICKUP_ASSIGNMENT_DRIVERS_COLUMN",
  PICKUP_ASSIGNMENT_MANIFEST_MAP: "PICKUP_ASSIGNMENT_MANIFEST_MAP",
  GET_DASHBOARD: "GET_DASHBOARD",
  PICKUP_INBOX_MESSAGES: "pickupInboxMessages",
  PICKUP_INBOX_MESSAGE_DETAIL: "pickupInboxMessageDetail",
  PICKUP_INBOX_STATS: "pickupInboxStats",
  PICKUP_INBOX_STATS_SUMMARY: "pickupInboxStatsSummary",
  PICKUP_INBOX_STATS_ANALYTICS: "pickupInboxStatsAnalytics",
  PICKUP_INBOX_BOL_SNAPSHOT: "pickupInboxBolSnapshot",
  PICKUP_INBOX_PICKUP_REQUEST: "pickupInboxPickupRequest",
  PICKUP_INBOX_EMAIL_MIME: "pickupInboxEmailMime",
  PICKUP_INBOX_REQUESTER_TEAM_BY_EMAIL: "pickupInboxRequesterTeamByEmail",
  PICKUP_REQUEST_EMAIL_BY_PICKUP_NUMBER: "pickupRequestEmailByPickupNumber",
  DOCK_EMPLOYEES: "dockEmployees",
  DOCK_EMPLOYEE_DETAIL: "dockEmployeeDetail",
  DOCK_TAGS: "dockTags",
  DOCK_ACTIVE_SESSIONS: "dockActiveSessions",
  DOCK_OPERATIONS_SUMMARY: "dockOperationsSummary",
  DOCK_SCAN_LOGS: "dockScanLogs",
  DOCK_SCAN_LOG_DETAIL: "dockScanLogDetail",
  DOCK_AUTH_EVENTS: "dockAuthEvents",
  DOCK_LAST_LOGINS: "dockLastLogins",
  DOCK_EQUIPMENT_ASSIGNMENTS: "dockEquipmentAssignments",
  DOCK_EMPLOYEE_ACTIVITY: "dockEmployeeActivity",
  SHIPMENT_MERGED_DOCK_LOG: "shipmentMergedDockLog",
  PICKUP_DUPLICATE_CHECK: "pickupDuplicateCheck",
};
